module.exports = new __parcel__URL__("CONUS_Nitrate_07012018.5dedd26a.png").toString();